import { CONSTANTS } from "utils/constants";

export const DATAGRID_MAX_NUMBER_OF_COLUMNS = 10;
export const DATAGRID_MAX_NUMBER_OF_ROWS = 100;
export const MAX_OPTION_LENGTH = CONSTANTS.FIELD_CONSTANTS.MAX_OPTION_LENGTH;
// The format the backend checks on `CurrencyCode`.
export const CURRENCY_CODE_PATTERN = /^[A-Z]{3}$/;
